/**
 * Canonical field type keys aligned with backend FieldDefinition.FieldType.
 * When the backend adds a type, add its key here and register it in registryMetadata.js.
 */
export const BACKEND_FIELD_TYPE_KEYS = [
  "STRING",
  "URL",
  "INTEGER",
  "DOUBLE",
  "BOOLEAN",
  "DATE",
  "DATETIME",
  "TIME",
  "PERIOD",
  "STRING_ARRAY",
  "ENUM",
  "COMBOLIST",
  "CURRENCY",
];
